import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "What is PCOD?",
    answer:
      "PCOD (Polycystic Ovarian Disease) is a hormonal disorder causing enlarged ovaries with small cysts on the outer edges. It may affect menstruation, fertility, and hormone levels.",
  },
  {
    question: "What are the common symptoms?",
    answer:
      "Irregular periods, weight gain, acne, excessive hair growth, hair thinning, and difficulty conceiving are common PCOD symptoms.",
  },
  {
    question: "How is PCOD treated?",
    answer:
      "Treatment includes lifestyle changes, dietary management, medications to regulate hormones or improve fertility, and regular monitoring by a gynecologist.",
  },
  {
    question: "Can PCOD affect fertility?",
    answer:
      "Yes, PCOD can impact ovulation, making conception more challenging. Early treatment and management improve fertility outcomes.",
  },
  {
    question: "Are there lifestyle changes that help?",
    answer:
      "Yes! Balanced diet, regular exercise, stress management, and maintaining healthy weight are very important in managing PCOD.",
  },
];

const AccordionItem = ({ index, faq, isActive, onClick }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isActive ? contentRef.current.scrollHeight : 0);
    }
  }, [isActive]);

  return (
    <motion.div
      className="bg-white rounded-xl shadow-md overflow-hidden"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.2 }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
    >
      <button
        onClick={onClick}
        className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none font-medium text-gray-700 text-lg cursor-pointer"
      >
        {faq.question}
        {isActive ? (
          <FaChevronUp className="text-pink-600 transition-transform duration-300" />
        ) : (
          <FaChevronDown className="text-pink-600 transition-transform duration-300" />
        )}
      </button>

      <motion.div
        animate={{ height }}
        initial={{ height: 0 }}
        transition={{
          duration: 0.4,
          type: "spring",
          stiffness: 200,
          damping: 30,
        }}
        className="overflow-hidden px-5 text-gray-600 text-sm"
      >
        <div ref={contentRef} className="pb-4">
          {faq.answer}
        </div>
      </motion.div>
    </motion.div>
  );
};

const ScreenSix = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-12">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          className="text-3xl sm:text-5xl font-bold text-pink-600 mb-12 text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Frequently Asked Questions
        </motion.h2>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <AccordionItem
              key={idx}
              index={idx}
              faq={faq}
              isActive={activeIndex === idx}
              onClick={() => setActiveIndex(activeIndex === idx ? null : idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScreenSix;
